<template>
    <div>
        <v-card color="#FFFFFF" style="border-left: none; border-right: none;">
            <v-col>
                <v-row style="background-color:#0D111B">
                    <v-col cols="12" lg="9" class="py-0 px-0">
                        <v-tabs
                            class="d-flex justify-center"
                            :height="$vuetify.breakpoint.lgAndUp ? '70' : ''"
                            background-color="#0D111B"
                            slider-color="#45D0D2"
                            show-arrows="mobile"
                        >
                            <v-tab :style="$vuetify.breakpoint.mdAndDown ? 'min-width:30px !important;' : ''" @click="tabOne" active-class="tab-gradient-bg">
                                <div><v-img :src="require('@/assets/images/All.svg')"></v-img></div>
                            </v-tab>
                            <v-tab :style="$vuetify.breakpoint.mdAndDown ? 'min-width:30px !important;' : ''" @click="tabTwo" active-class="tab-gradient-bg">
                                <div><v-img :src="require('@/assets/images/Dota.svg')"></v-img></div>
                            </v-tab>
                            <v-tab :style="$vuetify.breakpoint.mdAndDown ? 'min-width:30px !important;' : ''" @click="tabThree" active-class="tab-gradient-bg">
                                <div><v-img :src="require('@/assets/images/CSGO.svg')"></v-img></div>
                            </v-tab>
                            <v-tab :style="$vuetify.breakpoint.mdAndDown ? 'min-width:30px !important;' : ''" @click="tabFour" active-class="tab-gradient-bg">
                                <div><v-img :src="require('@/assets/images/LOL.svg')"></v-img></div>
                            </v-tab>
                            <v-tab :style="$vuetify.breakpoint.mdAndDown ? 'min-width:30px !important;' : ''" @click="tabFive" active-class="tab-gradient-bg">
                                <div><v-img :src="require('@/assets/images/Valorant.svg')"></v-img></div>
                            </v-tab>
                            <v-tab :style="$vuetify.breakpoint.mdAndDown ? 'min-width:30px !important;' : ''" @click="tabSix" active-class="tab-gradient-bg">
                                <div><v-img :src="require('@/assets/images/NBA.svg')"></v-img></div>
                            </v-tab>
                            <v-tab :style="$vuetify.breakpoint.mdAndDown ? 'min-width:30px !important;' : ''" @click="tabSeven" active-class="tab-gradient-bg">
                                <div><v-img :src="require('@/assets/images/Boxing.svg')"></v-img></div>
                            </v-tab>
                        </v-tabs>
                    </v-col>
                    <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="12" lg="3" class="d-flex align-center">
                        <v-text-field
                            class="mr-16 rounded-pill"
                            label="Search certain match, team and outright."
                            prepend-inner-icon="mdi-magnify"
                            hide-details
                            outlined
                            dense
                            background-color="#0D111B"
                            color="white"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-card>
        <div v-if="$vuetify.breakpoint.mdAndDown" class="mt-3" style="background-color:transparent !important;">
            <v-row class="d-flex justify-center" no-gutters>
                <v-col cols="10">
                    <v-text-field
                        class="rounded-pill"
                        placeholder="Search certain match, team and outright."
                        hide-details
                        outlined
                        dense
                        background-color="#0D111B"
                        color="white"
                        style="font-size: 12px !important;"
                    >
                        <template v-slot:prepend-inner>        
                            <v-icon small>mdi-magnify</v-icon> 
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            route_path: ""
        }
    },
    mounted() {
        this.route_path = this.$route.path;
    },
    methods: {
        tabOne() {
            if (this.$route.query.category != "") {
                this.$router.push({
                    path:this.route_path,
                    query:{...this.$route.query, category:""}
                });
                this.$emit("selected_tab", "All");
            }
        },
        tabTwo() {
            if (this.$route.query.category != "Dota") {
                this.$router.push({
                    path:this.route_path,
                    query:{...this.$route.query, category:"Dota"}
                });
                this.$emit("selected_tab", "Dota");
            }
        },
        tabThree() {
            if (this.$route.query.category != "CS:GO") {
                this.$router.push({
                    path:this.route_path,
                    query:{...this.$route.query, category:"CS:GO"}
                });
                this.$emit("selected_tab", "CS:GO");
            }
        },
        tabFour() {
            if (this.$route.query.category != "LOL") {
                this.$router.push({
                    path:this.route_path,
                    query:{...this.$route.query, category:"LOL"}
                });
                this.$emit("selected_tab", "LOL");
            }
        },
        tabFive() {
            if (this.$route.query.category != "Valorant") {
                this.$router.push({
                    path:this.route_path,
                    query:{...this.$route.query, category:"Valorant"}
                });
                this.$emit("selected_tab", "Valorant");
            }
        },
        tabSix() {
            if (this.$route.query.category != "NBA") {
                this.$router.push({
                    path:this.route_path,
                    query:{...this.$route.query, category:"NBA"}
                });
                this.$emit("selected_tab", "NBA");
            }
        },
        tabSeven() {
            if (this.$route.query.category != "Boxing") {
                this.$router.push({
                    path:this.route_path,
                    query:{...this.$route.query, category:"Boxing"}
                });
                this.$emit("selected_tab", "Boxing");
            }
        },
    }
};
</script>
<style scoped>
.tab-gradient-bg {
    background: linear-gradient(360deg, rgba(69, 207, 210, 0.25) 0%, rgba(69, 207, 210, 0) 100%);
}
</style>
<style>
.v-input__prepend-inner {
    margin: 0 !important;
    align-self: center !important;
}
</style>